define('WineRingRec.Recommendations.View', [
    'Backbone',
    'jQuery',
    'underscore',
    'Utils',
    'SC.Configuration',
    'Profile.Model',
    'Item.Collection',
    'Facets.ItemCell.View',
    'facets_item_cell_grid.tpl',
    '_wine_ring_rec_recommendations_view.tpl'
], function WineRingRecRecommendationsView(
    Backbone,
    jQuery,
    _,
    Utils,
    Configuration,
    ProfileModel,
    ItemCollection,
    FacetsItemCellView,
    facetsItemCellGrid,
    ViewTpl
) {
    'use strict';

    return Backbone.View.extend({

        template: ViewTpl,

        getTitle: function getTitle() {
            return Utils.translate('Instant Recommendations Results');
        },

        getConfigPerStore: function getConfigPerStore() {
            this.store = ProfileModel.getInstance().get('store');
            if (this.store) {
                return _.findWhere(Configuration.get('WineRingRec.configPerStore', []), { store: this.store.get('internalid').toString() });
            }
            return null;
        },
        showError: function showError() {
            return null;
        },
        initialize: function initialize(options) {
            var self = this;
            var instarec;
            var config;
            this.application = options.application;
            this.on('afterViewRender', function afterViewRenderFn() {
                self.listenTo(Backbone.Events, 'WineRingRec:Script.Loaded', function LiveOrderChangeStore() {
                    config = this.getConfigPerStore() || {};
                    instarec = jQuery('body').wrInstantRec({
                        integration_id: config.integrationId || '8299',
                        questionnaire_id: config.questionnaireId || '17',
                        resultsRedirect: config.resultsRedirect || 'recommendations',
                        resultsPerPage: 3,
                        customStyling: {
                            basicButton: 'basic-button',
                            results: {
                                heading: 'heading-class',
                                container: 'winering-container',
                                rowClass: 'facets-items-collection-view-row-three'
                            },
                            sidemenu: {
                                item: 'item-menu-custom'
                            }
                        }
                    });
                    instarec.wrInstantRec('show', {
                        type: 'results',
                        element: jQuery('#results'),
                        // Additional Options can be adding in here as well
                        customText: {
                            resultLoader: Utils.translate('Getting Recommendations')
                        },
                        error: {
                            text: '<h1>' + Utils.translate('Unable to process your recommendations at this time') + '</h1>'
                        },
                        onRenderComplete: function onRenderComplete() {
                            // console.log('render complete');
                        },
                        renderProductCards: function renderProductCards(lookups) {
                            var itemCollection = new ItemCollection();
                            var itemsId = _.pluck(lookups, 'value');
                            var promise;
                            var arrayString = [];
                            var itemView;
                            var fetchWineCardLocal;
                            itemCollection.searchApiMasterOptions = Configuration.get('searchApiMasterOptions.Facets', {});
                            promise = jQuery.Deferred();
                            // eslint-disable-next-line no-undef
                            fetchWineCardLocal = new Promise(function executorFn(resolveFn) {
                                itemCollection.fetch(
                                    {
                                        data: { id: itemsId.join(',') },
                                        error: function fnError(model, jqXhr) {
                                            jqXhr.preventDefault = true;
                                        }
                                    })
                                    .then(function thenFn() {
                                        _.each(itemCollection.models, function mapFn(model) {
                                            var urlcomponent;
                                            var dataParams = {
                                                'utm_campaign': Configuration.get('WineRingRec.utmCampaing'),
                                                'utm_source': Configuration.get('WineRingRec.utmSource'),
                                                'utm_medium': Configuration.get('WineRingRec.utmMedium')
                                            };
                                            if (model.get('custitem_sca_store').indexOf(self.store.get('name')) > -1) {
                                                urlcomponent = model.get('urlcomponent');
                                                model.set('_url', urlcomponent + '?' + jQuery.param(dataParams));
                                                itemView = new FacetsItemCellView({
                                                    model: model,
                                                    application: self.application
                                                });
                                                itemView.template = facetsItemCellGrid;
                                                itemView.model = model;
                                                arrayString.push(itemView.render().$el.html());
                                            }
                                        });
                                        resolveFn(arrayString);
                                    })
                                    .fail(function errorFn(error) {
                                        promise.reject(error);
                                    });
                            });

                            return fetchWineCardLocal
                                .then(function thenFnH(htmlString) {
                                    return htmlString;
                                })
                                .catch(function errorFnE(error) {
                                    return error;
                                });
                        }
                    });
                });
            });
        }
    });
});
